import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("mask", {
		id: "mask0_6841_815",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 32,
		height: 32,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			fill: "#7A409D"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16,
			stroke: "currentColor"
		})]
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_6841_815)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				opacity: .3,
				children: /* @__PURE__ */ _jsx("path", {
					opacity: .3,
					d: "M28.4202 0.703372C27.2764 0.702264 26.1798 0.247392 25.3711 -0.561374C24.5623 -1.37014 24.1075 -2.46674 24.1063 -3.61051V-9.6001H4.82996C3.33685 -9.6001 1.90491 -9.00695 0.849122 -7.95116C-0.206666 -6.89537 -0.799805 -5.46345 -0.799805 -3.97034V29.9673C-0.797587 31.459 -0.203476 32.8888 0.852071 33.9427C1.90762 34.9967 3.3383 35.5887 4.82996 35.5887H27.9704C29.4621 35.5887 30.8928 34.9967 31.9483 33.9427C33.0039 32.8888 33.598 31.459 33.6002 29.9673V0.703372H28.4202Z",
					fill: "#821C1A"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.166 5.59985H7.05813C6.88368 5.59985 6.71638 5.53054 6.59303 5.4072C6.46968 5.28385 6.40039 5.11656 6.40039 4.94211C6.40085 4.76797 6.47035 4.60111 6.59365 4.47814C6.71695 4.35517 6.88399 4.28613 7.05813 4.28613H25.166C25.34 4.28613 25.5069 4.35521 25.6299 4.47823C25.7529 4.60125 25.822 4.76814 25.822 4.94211C25.8222 5.02841 25.8054 5.1139 25.7726 5.19369C25.7397 5.27348 25.6914 5.34597 25.6305 5.40707C25.5696 5.46817 25.4972 5.51667 25.4175 5.54975C25.3378 5.58282 25.2523 5.59985 25.166 5.59985Z",
				fill: "#FFC9C8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.166 1.8955H7.05813C6.88368 1.8955 6.71638 1.8262 6.59303 1.70285C6.46968 1.5795 6.40039 1.41221 6.40039 1.23777C6.40085 1.06363 6.47035 0.896768 6.59365 0.773798C6.71695 0.650828 6.88399 0.581786 7.05813 0.581787H25.166C25.34 0.581787 25.5069 0.650906 25.6299 0.773926C25.7529 0.896947 25.822 1.06379 25.822 1.23777C25.8222 1.32406 25.8054 1.40955 25.7726 1.48934C25.7397 1.56913 25.6914 1.64166 25.6305 1.70276C25.5696 1.76386 25.4972 1.81233 25.4175 1.8454C25.3378 1.87848 25.2523 1.8955 25.166 1.8955Z",
				fill: "#FFC9C8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.2236 12.8867H14.2578C14.0837 12.8867 13.9167 12.8177 13.7934 12.6947C13.6701 12.5717 13.6006 12.4049 13.6001 12.2307C13.6001 12.0563 13.6694 11.889 13.7927 11.7657C13.9161 11.6423 14.0834 11.573 14.2578 11.573H25.2236C25.3977 11.5735 25.5646 11.643 25.6876 11.7663C25.8105 11.8895 25.8796 12.0566 25.8796 12.2307C25.8791 12.4046 25.8099 12.5711 25.6869 12.6941C25.564 12.817 25.3974 12.8863 25.2236 12.8867Z",
				fill: "#FFC9C8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.2236 9.18237H14.2578C14.0837 9.18237 13.9167 9.11328 13.7934 8.99031C13.6701 8.86734 13.6006 8.70053 13.6001 8.52639C13.6001 8.35195 13.6694 8.18461 13.7927 8.06126C13.9161 7.93791 14.0834 7.86865 14.2578 7.86865H25.2236C25.3977 7.86912 25.5646 7.93861 25.6876 8.06191C25.8105 8.1852 25.8796 8.35225 25.8796 8.52639C25.8791 8.70022 25.8099 8.86679 25.6869 8.98971C25.564 9.11264 25.3974 9.18191 25.2236 9.18237Z",
				fill: "#FFC9C8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.445 7.86865H7.34394C6.80341 7.86865 6.36523 8.30684 6.36523 8.84736V11.9484C6.36523 12.4889 6.80341 12.9271 7.34394 12.9271H10.445C10.9855 12.9271 11.4237 12.4889 11.4237 11.9484V8.84736C11.4237 8.30684 10.9855 7.86865 10.445 7.86865Z",
				fill: "#FFC9C8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.37964 20.1841V21.5179H8V20.1841H9.37964Z",
				fill: "#AB2E2E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4085 19.5822V21.5176H10.0747V16.001H12.2359C12.8909 16.001 13.3917 16.1642 13.7348 16.489C13.9084 16.6596 14.0439 16.865 14.1324 17.0917C14.221 17.3184 14.2605 17.5613 14.2485 17.8044C14.2551 18.1251 14.176 18.4418 14.0191 18.7217C13.859 18.9953 13.6215 19.2155 13.3367 19.3547C12.993 19.5171 12.6158 19.5957 12.2359 19.584L11.4085 19.5822ZM12.8909 17.8044C12.8909 17.3151 12.623 17.0705 12.0873 17.0705H11.4085V18.5071H12.0873C12.623 18.5119 12.8909 18.2777 12.8909 17.8044Z",
				fill: "#AB2E2E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.5193 20.1876C19.2896 20.6047 18.9426 20.9454 18.5213 21.1673C18.0472 21.41 17.52 21.5304 16.9876 21.5177H14.9053V16.001H16.9876C17.5204 15.9876 18.0484 16.1054 18.525 16.3441C18.9452 16.5612 19.2913 16.8984 19.5193 17.3128C19.7581 17.7526 19.8782 18.2471 19.8679 18.7474C19.8779 19.2495 19.7578 19.7456 19.5193 20.1876ZM18.0847 19.9106C18.2338 19.7575 18.3493 19.575 18.4239 19.3747C18.4985 19.1744 18.5304 18.9608 18.5176 18.7474C18.5305 18.5344 18.4986 18.321 18.424 18.121C18.3494 17.921 18.2339 17.7388 18.0847 17.5861C17.751 17.2933 17.3151 17.1443 16.872 17.1715H16.239V20.3234H16.872C17.3147 20.3503 17.7503 20.202 18.0847 19.9106Z",
				fill: "#AB2E2E"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.2217 16.001V17.0632H21.9596V18.2722H23.7062V19.2868H21.9596V21.5176H20.624V16.001H24.2217Z",
				fill: "#AB2E2E"
			})
		]
	})]
});
export default SvgPdf;
